import programs from '../api/programs'

export default {
    state: {
        programs: [],
        filters:[],
        currentProgram: {},
        currentProgramHistory: [],
        programsCanNotBeDeleted: [],
    },
    namespaced: true,
    mutations: {
        async savePrograms(state, programsData) {
            state.programs = programsData.programs;
            state.filters = programsData.filters;
        },
        async createProgram(state, programData) {
            //state.programs = [...state.programs.filter(p => p.id !== programData.id)];
            //state.programs.push(programData)
            state.currentProgram = programData
        },
        async getProgramHistory(state, programHistory) {
            //state.programs = [...state.programs.filter(p => p.id !== programData.id)];
            //state.programs.push(programData)
            state.currentProgramHistory = programHistory
        },

        async getProgramsCanNotBeDeleted(state, programs) {
            state.programsCanNotBeDeleted = programs;
        }
    },
    actions: {
        async getPrograms({dispatch, commit}, data) {
            commit('savePrograms', await programs.getPrograms(data));
        },
        async createProgram({dispatch, commit}, data) {
            commit('createProgram', await programs.createProgram(data));
        },
        async getProgramHistory({dispatch, commit}, data) {
            commit('getProgramHistory', await programs.getProgramHistory(data));
        },
        async getProgramsCanNotBeDeleted({dispatch, commit}, data) {
            commit('getProgramsCanNotBeDeleted', await programs.getProgramsCanNotBeDeleted());
        }
    },
    getters: {
        programs: state => state.programs,
        filters: state => state.filters,
        getCurrentProgram: state => state.currentProgram,
        getCurrentProgramHistory: state => state.currentProgramHistory,
        getProgramsCanNotBeDeleted: state => state.programsCanNotBeDeleted,
    },
}
